export function timestampToMillis(value) {
  if (!value) return 0;
  if (typeof value.toMillis === "function") return value.toMillis();
  if (value instanceof Date) return value.getTime();
  if (typeof value === "object" && Number.isFinite(value.seconds)) {
    return value.seconds * 1000 + Math.floor((value.nanoseconds || 0) / 1e6);
  }

  const parsed = Date.parse(value);
  return Number.isNaN(parsed) ? 0 : parsed;
}

export function compareCreatedAtDesc(a, b) {
  return timestampToMillis(b.createdAt) - timestampToMillis(a.createdAt);
}

export function compareEventDateAsc(a, b) {
  const aTime = timestampToMillis(a.eventDate) || timestampToMillis(`${a.startDate || a.date || ""}T${a.startTime || a.time || "00:00"}`);
  const bTime = timestampToMillis(b.eventDate) || timestampToMillis(`${b.startDate || b.date || ""}T${b.startTime || b.time || "00:00"}`);
  return aTime - bTime;
}

export function compareEventDateDesc(a, b) {
  const aTime = timestampToMillis(a.eventDate) || timestampToMillis(`${a.startDate || a.date || ""}T${a.startTime || a.time || "00:00"}`);
  const bTime = timestampToMillis(b.eventDate) || timestampToMillis(`${b.startDate || b.date || ""}T${b.startTime || b.time || "00:00"}`);
  return bTime - aTime || compareCreatedAtDesc(a, b);
}

export function normalizeDirectoryItem(sourceCollection, id, data = {}) {
  return {
    ...data,
    id: `${sourceCollection}:${id}`,
    sourceCollection,
    sourceId: id,
    serviceType: data.serviceType || data.type || data.category || "Other",
    email: data.email || data.contactEmail || "",
    phone: data.phone || data.contactPhone || "",
    localGuide: data.localGuide === true || data.isLocal === true,
    highlighted: data.highlighted === true || data.promoted === true,
  };
}

export function normalizeMapLocation(sourceCollection, id, data = {}) {
  const lat = Number(data.lat ?? data.position?.lat);
  const lng = Number(data.lng ?? data.position?.lng);

  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

  return {
    ...data,
    id: `${sourceCollection}:${id}`,
    sourceCollection,
    sourceId: id,
    lat,
    lng,
    serviceType: data.serviceType || data.type || data.category || "Community",
    contact: data.contact || data.contactEmail || data.contactPhone || "",
  };
}
